import { BaseValidationRule, IValidateable, validationRule } from '@aurelia/validation';

@validationRule({
    aliases: [
      { name: 'matches', defaultMessage: `invalid \${$displayName}` },
    ]
})
export class MatchesPropertyRule extends BaseValidationRule {
  public constructor(private propertyName: string) {
    super('matches');
  }

  public execute(value: any, _object?: IValidateable): boolean {
    return value === null
    || value === undefined
    || value === ''
    || _object[this.propertyName] === null
    || _object[this.propertyName] === undefined
    || _object[this.propertyName] === ''
    || value === _object[this.propertyName];
  }
}
